const scrollElementToTop = (element: HTMLElement): void => {
	if (element.scrollTop > 0) {
		element.scrollTop = 0;
	}
};

/**
 * Reseta a posição de scroll ao navegar entre rotas.
 * Cobre `window`, `document` e ancestrais scrolláveis (ex.: wrapper do portal).
 */
const scrollPageToTop = (): void => {
	window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
	document.documentElement.scrollTop = 0;
	document.body.scrollTop = 0;

	const root = document.getElementById('root');
	let element: HTMLElement | null = root;

	while (element) {
		scrollElementToTop(element);
		element = element.parentElement;
	}
};

export { scrollPageToTop };
